(() => {
  'use strict';
  const root = document.getElementById('by-beach-club-radio');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  let config, labels;
  try {
    config = JSON.parse(root.querySelector('[data-by-radio-config]').textContent);
    labels = JSON.parse(root.querySelector('[data-by-radio-labels]').textContent);
  } catch (_) { return; }
  const tracks = (config.tracks || []).filter(t => t.id && t.title && /^https:\/\//.test(t.src));
  if (!tracks.length || config.enabled === false) return;
  const byId = new Map(tracks.map(t => [t.id, t]));
  const ids = tracks.map(t => t.id);
  const find = s => root.querySelector(s);
  const panel = find('#by-radio-panel');
  const launcher = find('[data-radio-action="launch"]');
  const playButton = find('[data-radio-action="play"]');
  const volumeInput = find('#by-radio-volume');
  const muteButton = find('[data-radio-action="mute"]');
  const status = find('[data-radio-status]');
  const sessionKey = 'byBeachClubSessionV' + String(config.version || 1);
  const volumeKey = 'byBeachClubVolumeV1';
  const read = (storage, key) => { try { return JSON.parse(storage.getItem(key)); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const saved = read(sessionStorage, sessionKey) || {};
  const ident = config.ident || {};
  const identInterval = Math.max(2, Math.min(12, Number(ident.everyCompletedTracks) || 3));
  let identAvailable = ident.enabled === true && ident.id && /^https:\/\//.test(ident.src || '');
  let identActive = !!identAvailable && saved.identActive === true;
  let resumeAfterIdent = identActive && Number.isFinite(saved.resumeAfterIdent) && saved.resumeAfterIdent >= 0 ? saved.resumeAfterIdent : null;
  let completedSinceIdent = Number.isInteger(saved.completedSinceIdent) ? Math.max(0, Math.min(identInterval, saved.completedSinceIdent)) : 0;
  const pref = read(localStorage, volumeKey);
  let volume = typeof pref === 'number' && Number.isFinite(pref) ? Math.max(0, Math.min(1, pref)) : 0.25;
  let audibleVolume = volume || 0.25;
  let shuffle = saved.shuffle === true;
  const shuffled = list => {
    const a = list.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };
  const validHistory = Array.isArray(saved.history) && saved.history.length && saved.history.every(id => byId.has(id));
  if (!validHistory) { identActive = false; resumeAfterIdent = null; }
  let bag = shuffle ? shuffled(ids) : ids.slice();
  let history = validHistory ? saved.history.slice(-128) : [bag.shift()];
  let cursor = validHistory && Number.isInteger(saved.cursor) ? Math.max(0, Math.min(history.length - 1, saved.cursor)) : 0;
  if (validHistory) bag = Array.isArray(saved.bag) && saved.bag.every(id => byId.has(id)) && new Set(saved.bag).size === saved.bag.length ? saved.bag.slice() : ids.filter(id => id !== history[cursor]);
  let wanted = saved.playing === true && Date.now() - Number(saved.updated) < 1800000;
  let resumePosition = validHistory && Number.isFinite(saved.position) ? saved.position : 0;
  let engaged = saved.engaged === true;
  let audio, serial = 0, lastSave = 0, creditsBuilt = false, lastPlayId = '';
  const failed = new Set();
  const current = () => byId.get(history[cursor]);
  const entry = () => identActive ? ident : current();
  const save = () => {
    write(sessionStorage, sessionKey, { history, cursor, bag, shuffle, engaged, identActive, resumeAfterIdent, completedSinceIdent, playing: wanted, position: resumePosition > 0 ? resumePosition : audio && audio.dataset.trackId === entry().id ? audio.currentTime || 0 : 0, updated: Date.now() });
  };
  const say = key => { status.textContent = labels[key] || ''; };
  const paint = () => {
    const playing = !!audio && !audio.paused && !audio.ended;
    root.classList.toggle('is-playing', playing);
    playButton.setAttribute('aria-label', playing || wanted ? labels.pause : labels.play);
    launcher.setAttribute('aria-label', engaged ? labels.open : labels.launch);
    launcher.title = launcher.getAttribute('aria-label');
    find('[data-radio-title]').textContent = entry().title;
    find('[data-radio-artist]').textContent = entry().artist + ' · ' + entry().album;
    find('[data-radio-action="shuffle"]').setAttribute('aria-pressed', String(shuffle));
    const percent = Math.round(volume * 100);
    volumeInput.value = String(percent);
    find('[data-radio-volume]').value = percent + '%';
    volumeInput.setAttribute('aria-valuetext', percent + '%');
    muteButton.setAttribute('aria-pressed', String(volume === 0));
    muteButton.setAttribute('aria-label', volume === 0 ? labels.unmute : labels.mute);
    if (audio) { audio.volume = volume; audio.muted = volume === 0; }
  };
  const makeAudio = () => {
    if (audio) return audio;
    audio = document.createElement('audio');
    audio.preload = 'none';
    audio.setAttribute('playsinline', '');
    audio.hidden = true;
    root.appendChild(audio);
    audio.volume = volume;
    audio.muted = volume === 0;
    audio.addEventListener('loadedmetadata', () => {
      if (resumePosition > 0 && Number.isFinite(audio.duration)) {
        try { audio.currentTime = Math.min(resumePosition, Math.max(0, audio.duration - 1)); } catch (_) {}
      }
      resumePosition = 0;
    });
    audio.addEventListener('playing', () => {
      if (!wanted) { audio.pause(); return; }
      if (!identActive) failed.delete(current().id);
      lastPlayId = entry().id;
      say('playing'); paint(); save();
    });
    audio.addEventListener('pause', () => { paint(); if (!wanted) say('paused'); });
    audio.addEventListener('waiting', () => { if (wanted) say('loading'); });
    audio.addEventListener('timeupdate', () => { if (Date.now() - lastSave > 3000) { lastSave = Date.now(); save(); } });
    audio.addEventListener('ended', () => {
      if (!wanted) return;
      if (identActive) {
        finishIdent(true);
      } else {
        completedSinceIdent++;
        if (identAvailable && completedSinceIdent >= identInterval) {
          identActive = true;
          select(true);
        } else next(true);
      }
    });
    audio.addEventListener('error', () => {
      if (!wanted) return;
      if (identActive) {
        identAvailable = false;
        finishIdent(true);
        return;
      }
      failed.add(current().id);
      if (failed.size >= tracks.length) { pause(); say('unavailable'); return; }
      say('error');
      next(true, true);
    });
    return audio;
  };
  const start = () => {
    wanted = true; engaged = true;
    const token = ++serial;
    const a = makeAudio();
    a.preload = 'auto';
    if (a.dataset.trackId !== entry().id) {
      a.dataset.trackId = entry().id;
      a.src = entry().src;
    }
    say('loading'); paint(); save();
    const promise = a.play();
    if (promise) promise.catch(error => {
      if (serial !== token || error.name === 'AbortError') return;
      if (error.name === 'NotAllowedError') { wanted = false; a.pause(); say('resume'); paint(); save(); }
      else if (identActive) {
        identAvailable = false;
        finishIdent(true);
      }
      else if (!a.error) { wanted = false; a.pause(); say('unavailable'); paint(); save(); }
    });
  };
  const pause = () => {
    wanted = false; serial++;
    if (audio) audio.pause();
    say('paused'); paint(); save();
  };
  const select = (autoplay, position = 0) => {
    resumePosition = position;
    serial++;
    if (audio) {
      audio.pause();
      audio.removeAttribute('src');
      delete audio.dataset.trackId;
      audio.load();
    }
    say(autoplay ? 'loading' : 'ready'); paint(); save();
    if (autoplay) start();
  };
  const finishIdent = autoplay => {
    const position = resumeAfterIdent;
    identActive = false; resumeAfterIdent = null;
    if (position !== null) select(autoplay, position);
    else { completedSinceIdent = 0; next(autoplay); }
  };
  const startListening = () => {
    if (identAvailable && ident.playOnUserStart === true && !identActive) {
      resumeAfterIdent = resumePosition > 0 ? resumePosition : audio && audio.dataset.trackId === current().id ? audio.currentTime || 0 : 0;
      completedSinceIdent = 0;
      identActive = true;
      select(true);
    } else start();
  };
  const next = (autoplay = wanted, skipFailures = false) => {
    if (identActive) { finishIdent(autoplay); return; }
    if (cursor < history.length - 1) cursor++;
    else {
      if (!bag.length) {
        bag = shuffle ? shuffled(ids) : ids.slice();
        if (bag.length > 1 && bag[0] === current().id) [bag[0], bag[1]] = [bag[1], bag[0]];
      }
      let id = bag.shift();
      if (skipFailures) {
        while (failed.has(id) && bag.length) id = bag.shift();
      }
      history.push(id);
      if (history.length > 128) history.shift();
      cursor = history.length - 1;
    }
    select(autoplay);
  };
  const previous = () => {
    const autoplay = wanted;
    if (identActive) {
      if (resumeAfterIdent === null) completedSinceIdent = 0;
      identActive = false; resumeAfterIdent = null;
      select(autoplay);
      return;
    }
    if (cursor > 0) cursor--;
    select(autoplay);
  };
  const buildCredits = () => {
    if (creditsBuilt) return;
    creditsBuilt = true;
    const fragment = document.createDocumentFragment();
    tracks.forEach(t => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.textContent = t.title; a.href = t.source; a.target = '_blank'; a.rel = 'noopener';
      const artist = document.createElement('a');
      artist.textContent = t.artist; artist.href = t.artistUrl || t.source; artist.target = '_blank'; artist.rel = 'noopener';
      li.append(a, document.createTextNode(' — '), artist, document.createTextNode(' · ' + t.license + (t.copyright ? ' · ' + t.copyright : '')));
      fragment.appendChild(li);
    });
    find('[data-radio-credit-list]').appendChild(fragment);
  };
  const open = () => {
    panel.hidden = false; launcher.setAttribute('aria-expanded', 'true');
  };
  const close = (focus = false) => {
    panel.hidden = true; launcher.setAttribute('aria-expanded', 'false');
    if (focus) launcher.focus();
  };
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-radio-action]');
    if (!button) return;
    const action = button.dataset.radioAction;
    if (action === 'launch') {
      if (panel.hidden) { open(); if (!engaged) startListening(); }
      else close();
    }
    if (action === 'close') close(true);
    if (action === 'play') wanted ? pause() : startListening();
    if (action === 'next') next();
    if (action === 'previous') previous();
    if (action === 'shuffle') {
      shuffle = !shuffle;
      bag = shuffle ? shuffled(bag) : ids.filter(id => bag.includes(id));
      paint(); save();
    }
    if (action === 'mute') {
      if (volume > 0) { audibleVolume = volume; volume = 0; }
      else volume = audibleVolume;
      write(localStorage, volumeKey, volume); paint(); save();
    }
  });
  volumeInput.addEventListener('input', () => {
    volume = Number(volumeInput.value) / 100;
    if (volume > 0) audibleVolume = volume;
    write(localStorage, volumeKey, volume); paint();
  });
  find('.by-radio__credits').addEventListener('toggle', buildCredits, { once: true });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) close(true); });
  document.addEventListener('click', event => { if (!panel.hidden && !event.composedPath().includes(root)) close(); });
  const visibleRect = element => {
    if (!element) return null;
    const r = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return r.width > 10 && r.height > 10 && style.visibility !== 'hidden' && style.display !== 'none' ? r : null;
  };
  const position = () => {
    let bottom = 20;
    const badge = visibleRect(document.querySelector('.grecaptcha-badge'));
    if (badge && badge.left > innerWidth / 2 && innerHeight - badge.bottom < 100) bottom = Math.max(16, innerHeight - badge.bottom);
    const chat = document.getElementById('redo-chat-widget');
    const chatRoot = chat && chat.shadowRoot;
    const nodes = [chatRoot && chatRoot.querySelector('#chat-widget-button'), ...document.querySelectorAll('#shopify-chat, #ShopifyChat, .m-sticky-addtocart, .m-sticky-add-to-cart, .cookie-banner')];
    nodes.forEach(node => {
      const r = visibleRect(node);
      if (r && r.left < 76 && r.right > 12 && r.top > innerHeight * .5 && r.bottom > innerHeight - bottom - 52 && r.top < innerHeight - bottom) bottom = Math.max(bottom, innerHeight - r.top + 12);
    });
    const value = Math.min(bottom, Math.max(20, innerHeight - 160));
    if (root.style.getPropertyValue('--by-radio-bottom') !== value + 'px') root.style.setProperty('--by-radio-bottom', value + 'px');
  };
  let frame;
  const schedulePosition = () => { if (!frame) frame = requestAnimationFrame(() => { frame = null; position(); }); };
  window.addEventListener('resize', schedulePosition, { passive: true });
  window.addEventListener('orientationchange', schedulePosition, { passive: true });
  const widgetObserver = new MutationObserver(schedulePosition);
  widgetObserver.observe(document.body, { childList: true });
  let watchedChat;
  const watchChat = () => {
    const chat = document.getElementById('redo-chat-widget');
    if (chat && chat.shadowRoot && !watchedChat) {
      watchedChat = new MutationObserver(schedulePosition);
      watchedChat.observe(chat.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    schedulePosition();
  };
  [0, 700, 2000, 5000, 10000].forEach(delay => setTimeout(watchChat, delay));
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', () => { if (document.hidden) save(); });
  window.addEventListener('pageshow', event => { if (event.persisted && wanted && audio && audio.paused) start(); });
  paint(); say(saved.playing && !wanted ? 'resume' : 'ready'); root.hidden = false;
  if (wanted) start();
})();



